/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Results_No_Matching_JobsInputs */

const en_no_results_no_matching_jobs = /** @type {(inputs: No_Results_No_Matching_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There are currently no job positions available that match your filters.`)
};

const de_no_results_no_matching_jobs = /** @type {(inputs: No_Results_No_Matching_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derzeit sind keine Stellenangebote verfügbar, die deinen Filterkriterien entsprechen.`)
};

/**
* | output |
* | --- |
* | "There are currently no job positions available that match your filters." |
*
* @param {No_Results_No_Matching_JobsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const no_results_no_matching_jobs = /** @type {((inputs?: No_Results_No_Matching_JobsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Results_No_Matching_JobsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_no_results_no_matching_jobs(inputs)
	return en_no_results_no_matching_jobs(inputs)
});